import React from 'react'

import { AppLinksBlock } from "@components"
import { Box } from "@mui/material"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks"
import { selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"


export default function sitesColumn(officeSelected) {
	const { reportType } = useReportBackendApiPath()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS
	return {
		name: 'name',
		render: (
			value, {
				id_report_execution,
				id_office_pickup,
				officeNoResults,
				status,
				hasCompetitionSites,
				hasDirectSites,
			}) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<AppLinksBlock
				reportExecutionID={id_report_execution}
				hasCompetitionSites={status !== 'running' && hasCompetitionSites}
				hasDirectSites={status !== 'running' && hasDirectSites}
				officeNoResults={officeNoResults}
				analyzerOffice={id_office_pickup}
				dor={status !== 'running'}
				lor={status !== 'running'}
				position={status !== 'running'}
				isRunning={status === 'running'}
				downMultiReport={false}
				downMultiExport={false}
				idOfficeHistoric={officeSelected}
				isExtras={!!reportType}
				isRating={isRating}
				isOneWay={isOneWay}
				showMatches
			/>
		</Box>
	}
}